export default __webpack_public_path__ + "img/5342d840fa2907ae48cd5ee2429ebda6.svg";